import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PersonaFisicaEstatalComponent } from './components/persona-fisica-components/persona-fisica-estatal/persona-fisica-estatal.component';
import { PersonaFisicaEstatalEdicionComponent } from './components/persona-fisica-components/persona-fisica-estatal-edicion/persona-fisica-estatal-edicion.component';
import { PersonaFisicaForaneaComponent } from './components/persona-fisica-components/persona-fisica-foranea/persona-fisica-foranea.component';
import { PersonaFisicaForaneaEdicionComponent } from './components/persona-fisica-components/persona-fisica-foranea-edicion/persona-fisica-foranea-edicion.component';
import { PersonaMoralEstatalComponent } from './components/persona-moral-components/persona-moral-estatal/persona-moral-estatal.component';
import { PersonaMoralEdicionComponent } from './components/persona-moral-components/persona-moral-edicion/persona-moral-edicion.component';
import { PersonaMoralForaneaComponent } from './components/persona-moral-components/persona-moral-foranea/persona-moral-foranea.component';

export const routes: Routes = [
  { path: '', redirectTo: 'persona-fisica-estatal', pathMatch: 'full' },

  // DIRECCIONES PERSONA FISICA


  { path: 'persona-fisica-estatal', component: PersonaFisicaEstatalComponent },

  {
    path: 'persona-fisica-estatal-edicion/:data',
    component: PersonaFisicaEstatalEdicionComponent,
  },
  { path: 'persona-fisica-foranea', component: PersonaFisicaForaneaComponent },

  {
    path: 'persona-fisica-foranea-edicion/:data',
    component: PersonaFisicaForaneaEdicionComponent,
  },

  // DIRECCIONES PERSONA MORAL

  { path: 'persona-moral-estatal', component: PersonaMoralEstatalComponent },

  {
    path: 'persona-moral-edicion/:data',
    component: PersonaMoralEdicionComponent,
  },

  { path: 'persona-moral-foranea', component: PersonaMoralForaneaComponent },


  { path: 'pagina-no-encontrada', component: PageNotFoundComponent },
  { path: '**', redirectTo: '/pagina-no-encontrada' },
];
